import React from "react";
import StaticDropdown from "./StaticDropdown";
import {
  DropdownItem,
  DynamicDropdownProps,
} from "../../Interfaces/dropdownInterfaces";

const DynamicDropdown: React.FC<DynamicDropdownProps> = ({
  inputId = 1,
  dropdown,
  getData,
  onChange,
  value,
  reFetchData = false,
  setRefetchData,
}: DynamicDropdownProps) => {
  const [options, setOptions] = React.useState<Array<DropdownItem>>([]);
  React.useEffect(() => {
    fetchData();
  }, [inputId]);

  React.useEffect(() => {
    if (!reFetchData) return;
    fetchData();
    if (setRefetchData) setRefetchData(false);
  }, [reFetchData]);

  const fetchData = () => {
    setOptions([]);
    getData(inputId)
      .then((res) => {
        setOptions(res);
      })
      .catch(() => {
        setOptions([]);
      });
  };

  return (
    <StaticDropdown
      options={options}
      dropdown={{
        ...dropdown,
        disabled: !options || !options.length ? true : dropdown.disabled,
      }}
      value={value}
      onChange={onChange}
    />
  );
};

export default DynamicDropdown;
